import { goodVibeCardEn, goodVibeDetailDialogEn } from "@domains/good-vibes/client/i18n/en.ts";

export const en = {
    HomeProfileWidget: {
        viewProfile: "View profile",
        error: "We couldn't load your profile right now."
    },
    HomeEngagementWidget: {
        title: "Your engagement score",
        recognition: "Recognition",
        wellness: "Wellness",
        viewMyScore: "View my engagement score",
        ring: {
            ariaLabel: "Overall engagement score",
            outOf: "out of {{max}}",
            valueLabel: "{{score}} out of {{max}}"
        },
        direction: {
            up: "up",
            down: "down"
        },
        empty: {
            title: "Your engagement score is taking shape",
            description: "This is where your engagement score will show up"
        },
        error: "We couldn't load your engagement score right now."
    },
    HomeSurveyWidget: {
        title: "Survey streak",
        streak: {
            weekly_one: "week survey streak!",
            weekly_other: "weeks survey streak!",
            bimonthly_one: "bi-weekly survey in a row!",
            bimonthly_other: "bi-weekly surveys in a row!",
            monthly_one: "month survey streak!",
            monthly_other: "months survey streak!",
            quarterly_one: "quarter survey streak!",
            quarterly_other: "quarters survey streak!"
        },
        markers: {
            openLabel: "Your recent pulse surveys — you haven't answered the current cycle yet",
            answeredLabel: "Your recent pulse surveys — you've answered the current cycle"
        },
        takeSurvey: "Take the survey",
        allSet: "You're all set",
        opensInNewTab: "Opens in a new tab",
        empty: {
            title: "Start your streak",
            description: "Answer your first pulse survey to start your streak."
        },
        error: "We couldn't load your survey streak right now."
    },
    HomeGoalsWidget: {
        title: "Goals",
        headline_one: "goal needs an update",
        headline_other: "goals need an update",
        ownedGoal_one: "goal",
        ownedGoal_other: "goals",
        viewAll: "View all goals",
        untitled: "Untitled goal",
        progressLabel: "{{progress}}%",
        progressAriaLabel: "{{title}} progress",
        freshness: {
            never: "Never updated",
            today: "Updated today",
            daysAgo_one: "Updated {{count}} day ago",
            daysAgo_other: "Updated {{count}} days ago",
            weeksAgo_one: "Updated {{count}} week ago",
            weeksAgo_other: "Updated {{count}} weeks ago"
        },
        rowAriaLabel: "{{title}} — see all your goals",
        noGoals: "You don't have any goals yet.",
        newGoal: "New goal",
        createError: "Error creating goal",
        draft: "Draft",
        finish: "Finish",
        draftsOnlyPrompt: "Finish setting up your goals",
        error: "We couldn't load your goals right now."
    },
    HomeFeedbackWidget: {
        heading: "Feedback",
        empty: "No replies to your feedback yet.",
        someoneReplied: "Someone replied",
        nameReplied: "{{name}} replied",
        toYourFeedback: "to feedback you shared",
        openThread: "Open feedback conversation",
        viewAll: "View all feedback",
        leaveSuggestion: "Leave a suggestion",
        error: "We couldn't load your feedback right now."
    },
    HomeMeetingsWidget: {
        reviewAgenda: "Review agenda"
    },
    HomeReviewsWidget: {
        title: "Reviews",
        titleWithCount_one: "{{count}} review to write",
        titleWithCount_other: "{{count}} reviews to write",
        dueDate: "Due {{date}}",
        overdue: "Overdue",
        viewAll: "View all reviews",
        review: {
            self: "Self review",
            manager: "Manager review",
            peer: "Peer review",
            upward: "Upward review"
        },
        sharedReview: {
            label: "Your review is ready to view",
            attribution: "Shared by {{name}}"
        },
        error: "We couldn't load your reviews right now."
    },
    HomeAgentMiniPanel: {
        inputLabel: "Ask your agent",
        sendLabel: "Send to your agent",
        placeholder1: "Update my goal for this quarter",
        placeholder2: "Help me prep for my 1:1",
        placeholder3: "Draft feedback for a peer"
    },
    HomeGoodVibesWidget: {
        title: "Good Vibes across your org",
        viewAll: "View all Good Vibes",
        opensInNewTab: "Opens in a new tab",
        send: "Send Good Vibes",
        empty: "Recognize a teammate to get Good Vibes flowing.",
        error: "We couldn't load Good Vibes right now.",
        liveRegion: {
            loading: "Loading Good Vibes…"
        },
        sealed: {
            badge: "New Good Vibes",
            pressAndHold: "Press and hold to open",
            ariaLabel: "A new Good Vibe from {{recipients}} — press and hold to open"
        },
        composeDialog: {
            title: "Send Good Vibes",
            recipientsLabel: "To",
            recipientsPlaceholder: "Add another",
            recipientsSearchPlaceholder: "Search people",
            recipientsSelectedLabel: "Selected recipients",
            recipientsEmpty: "No results",
            recipientsLoading: "Searching…",
            recipientsRemoveLabel: "Remove {{name}}",
            subjectLabel: "Subject",
            subjectPlaceholder: "What did they do?",
            writeOwnLabel: "Write your own, or pick a prompt.",
            useTypedLabel: 'Use "{{text}}"',
            customCategoryLabel: "Custom",
            changeSubjectLabel: "Change",
            messageLabel: "Message",
            messagePlaceholder: "Say what they did and why it mattered.",
            messageCharactersLeft: "{{count}} characters left",
            audienceLabel: "Audience",
            directLabel: "Direct",
            directDescription: "Only the recipients, their managers, and higher-ups can see this.",
            publicLabel: "Public",
            publicDescription: "Everyone at the company can see this.",
            fromLabel: "From {{name}}",
            cancelLabel: "Cancel",
            submitDirectLabel: "Send directly",
            submitPublicLabel: "Send public",
            discardChangesTitle: "Discard this Good Vibe?",
            discardChangesBody: "You have not sent this yet. Leaving now will lose what you have written.",
            discardChangesConfirmLabel: "Discard",
            discardChangesCancelLabel: "Keep editing",
            successMessage: "You just made someone's day!",
            successCloseLabel: "Close",
            mostUsedThisMonthLabel: "Most used this month",
            usageCountLabel: "{{count}} uses this month"
        },
        giveError: "Couldn't send. Please try again."
    },
    HomeGoodVibeCard: {
        ...goodVibeCardEn,
        visibility: {
            public: "Public",
            direct: "Direct"
        }
    },
    HomeGoodVibeDetailDialog: {
        ...goodVibeDetailDialogEn,
        addCommentError: "An error occurred while posting your reply. Please try again.",
        editCommentSuccess: "Reply updated",
        editCommentError: "An error occurred while updating your reply. Please try again.",
        deleteCommentSuccess: "Reply deleted",
        deleteCommentError: "An error occurred while deleting your reply. Please try again."
    },
    HomeFeedbackThreadDialog: {
        title: "Feedback",
        close: "Close",
        liveRegion: {
            loading: "Loading conversation"
        },
        error: "We couldn't load this conversation right now.",
        status: {
            awaiting: "Awaiting reply"
        }
    },
    HomeFeedbackReplyComposer: {
        textareaLabel: "Reply to feedback",
        placeholder: "Reply…",
        send: "Send reply",
        sending: "Sending reply…",
        successToast: "Reply sent",
        errorToast: "Couldn't send your reply. Please try again.",
        replyAnonymously: "Reply anonymously",
        revealIdentityErrorToast: "Unable to update anonymity for this conversation. Please try again."
    }
};
